// 尺寸454*320
import React, { useRef, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Button, Row, Col, Input, ConfigProvider } from 'antd'
import { Image as MobileImage, ImageViewer as MobileImageViewer } from 'antd-mobile'
import _ from 'lodash'
import { formatMessageNew } from '@/utils/common'
import { modalSuccess, destroyModal, modalErrorRefreshCode, modalConfirm, modalError } from '@/utils/modalUtils'
import {
  readRfid,
  resetRfid,
  rfidBind,
  getOrderByCarton,
  validUpc,
  validEpc,
  validateNextCarton,
  forceFinishCarton,
  validQrCode
} from '@/services/qrCode/binding'
import '@/pages/AndroidDevice/PhoneLayout.less'
import Global_Combined from '@/assets/images/qrCode/Global_Combined.png'
import Local_QR_Code from '@/assets/images/qrCode/Local_QR_Code.png'
let imageInfo1 = {
  img: Global_Combined
  // w: 320,
  // h: 76
}
let imageInfo2 = {
  img: Local_QR_Code,
  w: 76,
  h: 76
}
let errorModal = null
let errorUpcModal = null
let errorQrCodeModal = null
let successModal = null
let errorCartonModal = null
let errorNum = 0
let localSoInfo = {}
const QrCodeBindingPage = () => {
  const history = useHistory()
  const cartonInputRef = useRef(null)
  const upcInputRef = useRef(null)
  const epcInputRef = useRef(null)
  const qrCodeInputRef = useRef(null)
  const macState = useSelector(state => state.commonStore.mac)
  const deviceCode = useSelector(state => state.commonStore.deviceCode)
  // const rfPath = useSelector(state => state.commonStore.rfPath)
  const [upcValue, setUpcValue] = useState('')
  const [epcValue, setEpcValue] = useState('')
  const [qrCodeValue, setQrCodeValue] = useState('')
  const [cartonNoValue, setCartonNoValue] = useState('')
  // unit count 信息
  const [soInfo, setSoInfo] = useState({})
  const [upcProductCode, setUpcProductCode] = useState('')
  const [epcProductCode, setEpcProductCode] = useState('')
  const [orderNumbers, setOrderNumbers] = useState([])
  const [switchFlag, setSwitchFlag] = useState(true)
  const [bingResult, setBingResult] = useState('')
  const [inputReadOnly, setInputReadOnly] = useState(false)
  const [cartonEnterFlag, setCartonEnterFlag] = useState(false)
  const [upcEnterFlag, setUpcEnterFlag] = useState(false)
  const [epcEnterFlag, setEpcEnterFlag] = useState(false)
  const [qrCodeEnterFlag, setQrCodeEnterFlag] = useState(false)

  const queryHeader = {
    isRF: true,
    mac: macState,
    deviceCode,
    operator: deviceCode
  }

  // 页面初始化
  useEffect(() => {
    cartonInputRef.current.focus({ cursor: 'all' })
    console.log('window.innerHeight', window.innerHeight, window.innerWidth)
    // 监听全局键盘事件
    window.addEventListener('keyup', onWindowKeyUp)
    return () => {
      // 移除全局键盘事件
      window.removeEventListener('keyup', onWindowKeyUp)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  // 全局键盘事件
  const onWindowKeyUp = e => {
    if (e.keyCode === 0 && e.code === 'F23') {
      getEpcValueFun()
      return
    }
    if (e.keyCode === 13) {
      // 关闭 错误提示弹窗
      if (errorUpcModal) {
        destroyModal(errorUpcModal)
        errorUpcModal = null
        upcInputRef.current.focus({ cursor: 'all' })
        errorNum = 0
      }
      // 关闭 错误提示弹窗
      if (errorQrCodeModal) {
        destroyModal(errorQrCodeModal)
        errorQrCodeModal = null
        qrCodeInputRef.current && qrCodeInputRef.current.focus({ cursor: 'all' })
        errorNum = 0
      }
      // 关闭 错误提示弹窗-carton
      if (errorCartonModal) {
        destroyModal(errorCartonModal)
        errorCartonModal = null
        cartonInputRef.current.focus({ cursor: 'all' })
        errorNum = 0
      }
      // 关闭 错误提示弹窗-不需要获取焦点
      if (errorModal) {
        destroyModal(errorModal)
        errorModal = null
        errorNum = 0
      }
      // 关闭 成功提示弹窗
      if (successModal) {
        destroyModal(successModal)
        successModal = null
        errorNum = 0
      }
    }
  }
  // 清空carton NO 回车标志
  useEffect(() => {
    if (!cartonNoValue) {
      setUpcValue('')
      setEpcValue('')
      setQrCodeValue('')
      // 清空结果信息
      setBingResult('')
      // 清空unit count 信息
      localSoInfo = {}
      setSoInfo({})
      setUpcProductCode('')
      setEpcProductCode('')
      // 清空订单信息
      setOrderNumbers([])
      setCartonEnterFlag(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartonNoValue])
  // 校验epc
  useEffect(() => {
    if (epcValue) {
      // 校验epc
      validEpcFun()
    } else {
      setEpcProductCode('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [epcValue])
  // 执行绑定
  useEffect(() => {
    if (switchFlag) {
      if (upcEnterFlag && epcEnterFlag) {
        // 校验通过，开始绑定
        submitBinding()
      }
    } else {
      if (upcEnterFlag && qrCodeEnterFlag) {
        // 校验通过，开始绑定
        submitBinding()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [upcEnterFlag, epcEnterFlag, qrCodeEnterFlag])
  useEffect(() => {
    if (!upcValue) {
      setUpcProductCode('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [upcValue])
  const getEpcValueFun = () => {
    setEpcValue('')
    readRfid()
      .then(res => {
        const value = res?.resultData?.rfid
        if (value.split(',').length > 1) {
          if (errorNum !== 0) return
          errorNum = 1
          let str = formatMessageNew('languageObj.qrCode.multipleEpc')
          errorModal = modalErrorRefreshCode(
            {
              content: str
            },
            () => {
              errorModal = null
              errorNum = 0
            }
          )
          return
        }
        setEpcValue(value === 'null' ? '' : value)
        setEpcEnterFlag(false)
        resetRfid()
      })
      .catch(err => {
        if (errorNum !== 0) return
        errorNum = 1
        let str = formatMessageNew('languageObj.qrCode.readEpcErr')
        errorModal = modalErrorRefreshCode(
          {
            content: str
          },
          () => {
            errorModal = null
            errorNum = 0
          }
        )
      })
  }

  const onInputChange = (e, type) => {
    const value = e.target.value.trim()
    const index = value.indexOf('/n')
    const newValue = index > -1 ? value.substring(0, index) : value
    if (type === 'carton') {
      setCartonNoValue(newValue)
    }
    if (type === 'upc') {
      setUpcEnterFlag(false)
      setUpcValue(newValue)
    }
    if (type === 'qr') {
      setQrCodeEnterFlag(false)
      setQrCodeValue(newValue)
    }
  }

  const onInputKeyDown = (e, type) => {
    if (e.keyCode === 13) {
      if (type === 'carton') {
        getSoInfo()
      }
      if (type === 'upc') {
        // 检验upc
        validUpcFun()
      }
      if (type === 'qr') {
        // 检验Qr Code
        validQrCodeFun()
      }
    }
  }
  // 根据箱号获取订单信息
  const getSoInfo = () => {
    let params = {
      cartonNo: cartonNoValue
    }
    getOrderByCarton(params, queryHeader)
      .then(res => {
        setOrderNumbers(res.resultData.orderNumbers)
        localSoInfo = { ...res.resultData }
        setSoInfo(res.resultData)
        setCartonEnterFlag(true)
        setTimeout(() => {
          upcInputRef.current.focus({ cursor: 'all' })
        }, 300)
      })
      .catch(err => {
        let str = formatMessageNew('languageObj.qrCode.errorcode_' + err.errorCode)
        if (errorNum === 0) {
          errorNum = 1
          cartonInputRef.current.blur()
          errorCartonModal = modalErrorRefreshCode(
            {
              content: str || err.errorMessage
            },
            () => {
              cartonInputRef.current.focus({ cursor: 'all' })
              errorNum = 0
              errorCartonModal = null
            }
          )
        }
      })
  }
  const validUpcFun = async () => {
    if (cartonNoValue && upcValue) {
      let params = {
        cartonNo: cartonNoValue,
        upc: upcValue
      }
      let reslute = {}
      await validUpc(params, queryHeader)
        .then(res => {
          reslute = res
        })
        .catch(err => {
          reslute = err
        })
      if (reslute && reslute.resultData) {
        reslute.resultData.cartonUpcCount = localSoInfo.cartonUpcCount
        reslute.resultData.bindUpcCount = localSoInfo.bindUpcCount
        localSoInfo = { ...reslute.resultData }
        setSoInfo(reslute.resultData)
        setUpcProductCode(reslute.resultData.productCodeAndSize)
      }
      // 清空结果信息
      setBingResult('')
      if (reslute.errorCode !== '200') {
        errorMessageFun(reslute)
        return
      }
    }
    // upc校验通过，根据切换按钮判断哪个获取焦点
    if (switchFlag) {
      setTimeout(() => {
        epcInputRef.current && epcInputRef.current.focus({ cursor: 'all' })
      }, 100)
    } else {
      setTimeout(() => {
        qrCodeInputRef.current && qrCodeInputRef.current.focus({ cursor: 'all' })
      }, 100)
    }
    setUpcEnterFlag(true)
    console.log('upc通过')
  }
  const validEpcFun = async () => {
    if (switchFlag) {
      if (cartonNoValue && epcValue) {
        let paramsEpc = {
          cartonNo: cartonNoValue,
          epc: epcValue
        }
        let reslute = {}
        await validEpc(paramsEpc, queryHeader)
          .then(res => {
            reslute = res
          })
          .catch(err => {
            reslute = err
          })

        if (reslute && reslute.resultData) {
          reslute.resultData.cartonUpcCount = localSoInfo.cartonUpcCount
          reslute.resultData.bindUpcCount = localSoInfo.bindUpcCount
          localSoInfo = { ...reslute.resultData }
          setSoInfo(reslute.resultData)
          setEpcProductCode(reslute.resultData.productCodeAndSize)
        }
        // 清空结果信息
        setBingResult('')
        if (reslute.errorCode !== '200') {
          errorMessageFun(reslute)
          return
        }
      }
      setEpcEnterFlag(true)
      console.log('epc通过')
    }
  }
  const validQrCodeFun = async () => {
    if (!switchFlag) {
      if (cartonNoValue && qrCodeValue) {
        let params = {
          cartonNo: cartonNoValue,
          qrCode: qrCodeValue
        }
        let reslute = {}
        await validQrCode(params, queryHeader)
          .then(res => {
            reslute = res
          })
          .catch(err => {
            reslute = err
          })
        if (reslute.errorCode !== '200') {
          errorQrCodeMessageFun(reslute)
          return
        }
      }
      // upc校验通过，根据切换按钮判断哪个获取焦点
      setTimeout(() => {
        if (!upcValue) {
          upcInputRef.current.focus({ cursor: 'all' })
        }
      }, 100)
      setQrCodeEnterFlag(true)
      console.log('Qr Code通过')
    }
  }
  // 执行绑定
  const submitBinding = async () => {
    if (switchFlag) {
      if (cartonNoValue && upcValue && epcValue) {
        // 校验通过，开始绑定
        gotoRfidBind()
      }
    } else {
      if (cartonNoValue && upcValue && qrCodeValue) {
        // 校验通过，开始绑定
        gotoRfidBind()
      }
    }
  }
  const errorMessageFun = err => {
    upcInputRef.current.blur()
    qrCodeInputRef.current && qrCodeInputRef.current.blur()
    let strFormat = 'languageObj.qrCode.errorcode_' + err.errorCode
    let str = formatMessageNew(strFormat)
    if (errorNum === 0) {
      errorNum = 1
      errorUpcModal = modalErrorRefreshCode(
        {
          content: str || err.errorMessage
        },
        () => {
          upcInputRef.current.focus({ cursor: 'all' })
          errorNum = 0
          errorUpcModal = null
        }
      )
    }
  }
  const errorQrCodeMessageFun = err => {
    upcInputRef.current.blur()
    qrCodeInputRef.current && qrCodeInputRef.current.blur()
    let strFormat = 'languageObj.qrCode.errorcode_' + err.errorCode
    let str = formatMessageNew(strFormat)
    if (errorNum === 0) {
      errorNum = 1
      if (err.errorCode === '9000' || err.errorCode === '9001' || err.errorCode === '9002') {
        let str2 = getErrorMessageHtml(err)
        errorQrCodeModal = modalError(
          {
            content: str2
          },
          () => {
            // qrCodeInputRef && qrCodeInputRef.current && qrCodeInputRef.current({ cursor: 'all' })
            errorQrCodeModal = null
            errorNum = 0
          }
        )
      } else {
        errorQrCodeModal = modalErrorRefreshCode(
          {
            content: str || err.errorMessage
          },
          () => {
            // qrCodeInputRef && qrCodeInputRef.current && qrCodeInputRef.current({ cursor: 'all' })
            errorQrCodeModal = null
            errorNum = 0
          }
        )
      }
    }
  }
  const getErrorMessageHtml = (err = {}) => {
    let str = formatMessageNew('languageObj.qrCode.errorcode_' + err.errorCode)
    let resLs = []
    if (err.errorCode === '9000') {
      resLs.push(imageInfo2)
    }
    if (err.errorCode === '9001') {
      resLs.push(imageInfo1)
    }
    if (err.errorCode === '9002') {
      resLs.push(imageInfo1)
      resLs.push(imageInfo2)
    }
    let domStr = (
      <div>
        {str || err.errorMessage}
        <div className="displayFlex alignCenter justifyContentCenter flexDirectionC">
          {resLs.map((item, index) => {
            return (
              <div key={index} className="mt10">
                <MobileImage
                  src={item.img}
                  width={item.w}
                  height={item.h}
                  onClick={() => {
                    MobileImageViewer.Multi.show({ images: resLs.map(item => item.img), defaultIndex: index })
                  }}
                />
              </div>
            )
          })}
        </div>
      </div>
    )
    return domStr
  }
  const gotoRfidBind = () => {
    let params = {
      cartonNumber: cartonNoValue,
      upc: upcValue,
      rfidEpc: epcValue,
      qrCode: qrCodeValue
    }
    console.log('开始绑定')
    rfidBind(params, queryHeader)
      .then(res => {
        upcInputRef.current.blur()
        if (!switchFlag) {
          qrCodeInputRef.current.blur()
        }
        res.resultData.cartonUpcCount = localSoInfo.cartonUpcCount
        res.resultData.allProdCount = localSoInfo.allProdCount
        localSoInfo = { ...res.resultData }
        setSoInfo(res.resultData)
        if (errorNum === 0) {
          errorNum = 1
          successModal = modalSuccess(
            {
              content: formatMessageNew('languageObj.qrCode.bindByCartonSuccess')
            },
            () => {
              errorNum = 0
              successModal = null
            }
          )
        }
        if (switchFlag) {
          setBingResult('epc')
        } else {
          setBingResult('qrcode')
        }
      })
      .catch(err => {
        upcInputRef.current.blur()
        if (!switchFlag) {
          qrCodeInputRef.current.blur()
        }
        let str = formatMessageNew('languageObj.qrCode.errorcode_' + err.errorCode)
        if (errorNum === 0) {
          errorNum = 1
          if (err.errorCode === '9000' || err.errorCode === '9001' || err.errorCode === '9002') {
            let str2 = getErrorMessageHtml(err)
            errorUpcModal = modalError(
              {
                content: str2
              },
              () => {
                upcInputRef.current.focus({ cursor: 'all' })
                errorNum = 0
                errorUpcModal = null
              }
            )
          } else {
            errorUpcModal = modalErrorRefreshCode(
              {
                content: str || err.errorMessage
              },
              () => {
                upcInputRef.current.focus({ cursor: 'all' })
                errorNum = 0
                errorUpcModal = null
              }
            )
          }
        }
      })
  }
  const onEpcChange = e => {
    setEpcValue(e && e.target && e.target.value)
  }
  const onInputFocus = e => {
    try {
      setInputReadOnly(true)
      setTimeout(() => {
        setInputReadOnly(false)
      }, 100)
    } catch (error) {}
  }
  const switchBtn = () => {
    setSwitchFlag(!switchFlag)
    setEpcValue('')
    setQrCodeValue('')
  }
  useEffect(() => {
    try {
      // 切换按钮改变时，如果upc没值，upc要获取焦点
      if (!upcValue) {
        setTimeout(() => {
          upcInputRef.current && upcInputRef.current.focus({ cursor: 'all' })
        }, 100)
      } else {
        if (switchFlag) {
          setTimeout(() => {
            epcInputRef.current && epcInputRef.current.focus({ cursor: 'all' })
          }, 100)
        } else {
          setTimeout(() => {
            qrCodeInputRef.current && qrCodeInputRef.current.focus({ cursor: 'all' })
          }, 100)
        }
      }
    } catch (error) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [switchFlag])
  const nextCartonFun = () => {
    if (cartonNoValue) {
      let params = {
        cartonNo: cartonNoValue
      }
      validateNextCarton(params, queryHeader)
        .then(res => {
          console.log('res', res)
          let str = formatMessageNew('languageObj.qrCode.errorcode_10')
          let ls = []
          _.forIn(res.resultData || {}, (value, key) => {
            ls.push(`${key}*${value}`)
          })
          if (ls.length > 0) {
            errorCartonModal = modalConfirm(
              {
                content: `${str}${ls.join(';')}`,
                onCancel: () => {
                  errorCartonModal = null
                }
              },
              () => {
                forceFinishCarton(params, queryHeader)
                  .then(() => {
                    setCartonNoValue('')
                    cartonInputRef.current.focus({ cursor: 'all' })
                    errorCartonModal = null
                  })
                  .catch(err => {
                    let str = formatMessageNew('languageObj.qrCode.errorcode_' + err.errorCode)
                    if (errorNum === 0) {
                      errorNum = 1
                      errorCartonModal = modalErrorRefreshCode(
                        {
                          content: str || err.errorMessage
                        },
                        () => {
                          errorNum = 0
                          errorCartonModal = null
                        }
                      )
                    }
                  })
              }
            )
          } else {
            setCartonNoValue('')
            cartonInputRef.current.focus({ cursor: 'all' })
            errorCartonModal = null
          }
        })
        .catch(err => {
          let str = formatMessageNew('languageObj.qrCode.errorcode_' + err.errorCode)
          if (errorNum === 0) {
            errorNum = 1
            errorCartonModal = modalErrorRefreshCode(
              {
                content: str || err.errorMessage
              },
              () => {
                errorNum = 0
                errorCartonModal = null
              }
            )
          }
        })
    }
  }
  const nextEpcFun = () => {
    if (cartonNoValue && !bingResult) {
      if (upcValue || epcValue || qrCodeValue) {
        modalConfirm(
          {
            content: formatMessageNew('languageObj.qrCode.errorcode_11'),
            onCancel: () => {}
          },
          () => {
            setUpcValue('')
            setEpcValue('')
            setQrCodeValue('')
            // 清空结果信息
            setBingResult('')
            localSoInfo = { ...localSoInfo, bindProdCount: 0, allProdCount: 0 }
            setSoInfo({ ...localSoInfo, bindProdCount: 0, allProdCount: 0 })
            setUpcProductCode('')
            setEpcProductCode('')
            setSwitchFlag(true)
            upcInputRef.current.focus({ cursor: 'all' })
          }
        )
      }
    } else {
      setUpcValue('')
      setEpcValue('')
      setQrCodeValue('')
      // 清空结果信息
      setBingResult('')
      localSoInfo = { ...localSoInfo, bindProdCount: 0, allProdCount: 0 }
      setSoInfo({ ...localSoInfo, bindProdCount: 0, allProdCount: 0 })
      setUpcProductCode('')
      setEpcProductCode('')
      setSwitchFlag(true)
      upcInputRef.current.focus({ cursor: 'all' })
    }
  }
  const clearInfoFun = () => {
    setUpcValue('')
    setEpcValue('')
    setQrCodeValue('')
    localSoInfo = { ...localSoInfo, bindProdCount: 0, allProdCount: 0 }
    setSoInfo({ ...localSoInfo, bindProdCount: 0, allProdCount: 0 })
    // 清空结果信息
    setBingResult('')
    setUpcProductCode('')
    setEpcProductCode('')
    setSwitchFlag(true)
    upcInputRef.current.focus({ cursor: 'all' })
  }
  const clearCarton = () => {
    setCartonNoValue('')
    setTimeout(() => {
      cartonInputRef.current.focus({ cursor: 'all' })
    }, 100)
  }
  const backFirstPage = () => {
    history.push('/rf/login')
  }
  const clearFlag = upcValue || (switchFlag && epcValue) || (!switchFlag && qrCodeValue)

  return (
    <ConfigProvider
      theme={{
        token: {
          fontSize: 14
        }
      }}
    >
      <div
        style={{ height: 'auto', overflow: 'auto', marginLeft: -5, marginRight: -5 }}
        className="full-tag-wrapper qrcode-wrapper"
      >
        <div className="displayFlex alignCenter mt5">
          <div className="bind_label">{formatMessageNew('languageObj.qrCode.cartonNo')}：</div>
          <div className="bind_label2">
            <Input
              className="pt5 pb5"
              ref={cartonInputRef}
              value={cartonNoValue}
              disabled={cartonEnterFlag}
              allowClear
              readOnly={inputReadOnly}
              placeholder={`${formatMessageNew('languageObj.nsptagLocale.pleaseScan')}${formatMessageNew(
                'languageObj.qrCode.cartonNo'
              )}`}
              onFocus={onInputFocus}
              onKeyDown={e => onInputKeyDown(e, 'carton')}
              onChange={e => onInputChange(e, 'carton')}
            />
          </div>
        </div>
        {cartonEnterFlag && cartonNoValue ? (
          <div>
            <div>
              <div className="displayFlex alignCenter mt5">
                <div className="bind_label">{formatMessageNew('languageObj.qrCode.salesOrder')}：</div>
                <div className="bind_label2">
                  {(orderNumbers || []).map((item, idx) => {
                    return <div key={idx}>{item}</div>
                  })}
                </div>
              </div>

              <div className="displayFlex alignCenter mt5">
                <div className="bind_label">{formatMessageNew('languageObj.qrCode.upc')}：</div>
                <div className="bind_label2">
                  <Input
                    className="pt5 pb5"
                    ref={upcInputRef}
                    value={upcValue}
                    readOnly={inputReadOnly}
                    allowClear
                    placeholder={`${formatMessageNew('languageObj.nsptagLocale.pleaseScan')}${formatMessageNew(
                      'languageObj.qrCode.upc'
                    )}`}
                    onFocus={onInputFocus}
                    onKeyDown={e => onInputKeyDown(e, 'upc')}
                    onChange={e => onInputChange(e, 'upc')}
                  />
                </div>
              </div>

              <div className="displayFlex alignCenter">
                <div className="bind_label"></div>
                <div className="bind_label2">
                  <div style={{ minHeight: 24 }} className="color-primary">
                    {upcProductCode}
                  </div>
                </div>
              </div>

              <div
                style={{ display: switchFlag ? 'inline-flex' : 'none', width: '100%' }}
                className="displayFlex alignCenter mt5"
              >
                <div className="bind_label">{formatMessageNew('languageObj.qrCode.rfidEpc')}：</div>
                <div className="bind_label2">
                  <Input
                    className="pt5 pb5"
                    value={epcValue}
                    ref={epcInputRef}
                    readOnly={true}
                    placeholder={`${formatMessageNew('languageObj.nsptagLocale.pleaseScan')}${formatMessageNew(
                      'languageObj.qrCode.rfidEpc'
                    )}`}
                    onChange={onEpcChange}
                  />
                </div>
              </div>
              <div
                style={{ display: switchFlag ? 'none' : 'inline-flex', width: '100%' }}
                className="displayFlex alignCenter mt5"
              >
                <div className="bind_label">{formatMessageNew('languageObj.qrCode.qrCode')}：</div>
                <div className="bind_label2">
                  <Input
                    className="pt5 pb5"
                    value={qrCodeValue}
                    ref={qrCodeInputRef}
                    allowClear
                    readOnly={inputReadOnly}
                    placeholder={`${formatMessageNew('languageObj.nsptagLocale.pleaseScan')}${formatMessageNew(
                      'languageObj.qrCode.qrCode'
                    )}`}
                    onFocus={onInputFocus}
                    onKeyDown={e => onInputKeyDown(e, 'qr')}
                    onChange={e => onInputChange(e, 'qr')}
                  />
                </div>
              </div>
              <div className="displayFlex alignCenter">
                <div className="bind_label"></div>
                <div className="bind_label2">
                  <div style={{ minHeight: 24 }} className="color-primary">
                    {switchFlag && epcProductCode}
                  </div>
                </div>
              </div>

              <div className="displayFlex alignCenter mt5">
                <div className="bind_label2 alignC">
                  <ConfigProvider
                    theme={{
                      components: {
                        Button: {
                          borderColorDisabled: '#d9d9d9',
                          defaultBorderColor: switchFlag ? '#ffc000' : '#3671a3',
                          defaultBg: bingResult ? '#d9d9d9' : '#ffffff',
                          defaultActiveBorderColor: switchFlag ? '#ffc000' : '#3671a3',
                          defaultActiveBg: '#ffffff',
                          defaultActiveColor: '#000',
                          defaultHoverBorderColor: switchFlag ? '#ffc000' : '#3671a3',
                          defaultHoverBg: '#ffffff',
                          defaultHoverColor: '#000'
                        }
                      }
                    }}
                  >
                    <Button disabled={bingResult} className="phone-btn2" style={{ width: 'auto' }} onClick={switchBtn}>
                      {switchFlag
                        ? formatMessageNew('languageObj.qrCode.switchToQrCode')
                        : formatMessageNew('languageObj.qrCode.switchToRfidEpc')}
                    </Button>
                  </ConfigProvider>
                </div>
              </div>
              <div className="displayFlex alignCenter mt8">
                <div className="bind_label"> {formatMessageNew('languageObj.qrCode.bindResult')}：</div>
                <div className="bind_label2">
                  <div className="displayFlex">
                    <div
                      style={
                        bingResult === 'epc'
                          ? {
                              background: '#6ca744',
                              color: '#fff'
                            }
                          : {}
                      }
                      className="phone-btn2 b1ddd alignC"
                    >
                      {formatMessageNew('languageObj.qrCode.rfid')}
                    </div>
                    <div
                      style={
                        bingResult === 'qrcode'
                          ? {
                              background: '#6ca744',
                              color: '#fff'
                            }
                          : {}
                      }
                      className="phone-btn2 b1ddd ml10 alignC"
                    >
                      {formatMessageNew('languageObj.qrCode.qr')}
                    </div>
                  </div>
                </div>
              </div>

              <Row className="mt8">
                <Col span={12}>
                  {formatMessageNew('languageObj.qrCode.skuScanCount')}：{soInfo.bindProdCount}/{soInfo.allProdCount}
                </Col>
                <Col span={12}>
                  {formatMessageNew('languageObj.qrCode.unitScanCount')}：{soInfo.bindUpcCount}/{soInfo.cartonUpcCount}
                </Col>
              </Row>
            </div>
            <div className="pt10 pb10">
              <Row gutter={[0, 0]} justify="space-between">
                <Col span={5}>
                  <Button
                    disabled={!cartonNoValue}
                    type="primary"
                    className="phone-btn2 reset-btn mt0"
                    style={!cartonNoValue ? { background: '#d9d9d9' } : { background: '#6cc909' }}
                    onClick={nextCartonFun}
                  >
                    {`${formatMessageNew('languageObj.qrCode.nextCarton')}`}
                  </Button>
                </Col>
                <Col span={5}>
                  <Button
                    disabled={!bingResult}
                    type="primary"
                    className="phone-btn2 reset-btn mt0"
                    style={!bingResult ? { background: '#d9d9d9' } : { background: '#3671a3' }}
                    onClick={nextEpcFun}
                  >
                    {`${formatMessageNew('languageObj.qrCode.nextEpc')}`}
                  </Button>
                </Col>
                <Col span={5}>
                  <Button
                    onClick={clearInfoFun}
                    disabled={!clearFlag || bingResult}
                    type="primary"
                    className="phone-btn2 reset-btn mt0"
                    style={!clearFlag || bingResult ? { background: '#d9d9d9' } : { background: '#ffc000' }}
                  >
                    {`${formatMessageNew('languageObj.qrCode.clear')}`}
                  </Button>
                </Col>
                <Col span={5}>
                  <Button type="primary" className="phone-btn2 reset-btn mt0" onClick={clearCarton}>
                    {`${formatMessageNew('languageObj.qrCode.back')}`}
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        ) : (
          <div className="position-fixed-btn">
            <Button type="primary" className="phone-btn2 reset-btn mt0" onClick={backFirstPage}>
              {`${formatMessageNew('languageObj.qrCode.backFirstPage')}`}
            </Button>
          </div>
        )}
      </div>
    </ConfigProvider>
  )
}
export default QrCodeBindingPage
